import styled from 'styled-components';

import { Container as InputContainer } from '~/components/Formik/Input/styles';
import { Content as ModalContent } from '~/components/Modal/styles';
import { TabsHeader } from '~/components/TabsContainer/styles';
import colors from '~/styles/colors';
import grid from '~/styles/grid';

export const Container = styled.div`
  ${ModalContent} {
    max-width: 960px;
    width: 960px;
    max-height: 598px;

    padding: ${grid.lg} ${grid.lg} 0 ${grid.lg};

    @media (max-width: 1400px) {
      max-width: 860px;
      max-height: 498px;
    }
  }

  ${TabsHeader} {
    position: sticky;
    top: 0;
    z-index: 2;
  }

  .MuiBox-root {
    padding: ${grid.lg} 0 0 0;
  }
`;

export const Box = styled.div`
  display: flex;
  column-gap: ${grid.lg};
  margin-bottom: ${grid.lg};

  ${InputContainer} {
    div:first-child {
      font-weight: normal;
      margin: 0;
      margin-bottom: ${grid.xs};
    }
  }
`;

export const InputList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: ${grid.xl};
  row-gap: ${grid.lg};
`;

export const CepBox = styled.div`
  display: flex;
  column-gap: ${grid.lg};
  margin-bottom: ${grid.lg};
`;

export const ButtonBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  width: 100%;
  position: sticky;
  bottom: 0;
  background: white;
  width: 100%;
  button {
    width: 150px;
    margin: ${grid.xl} 0 ${grid.lg} 0;
  }
`;

export const Content = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
`;

export const ImageContainer = styled.div`
  img {
    display: block;

    width: 80px;
    height: 80px;
    border-radius: 50%;
    &:hover {
      background: rgba(0, 0, 0, 0.6);
    }
  }
`;

export const OverlayBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  color: #ffffff;
  opacity: 0;

  p {
    font-size: 12px;
    text-align: center;
  }

  &:hover {
    opacity: 1;
    border: 2px solid ${colors.primary};
  }
`;
